import React from 'react';
import PropTypes from 'prop-types';
import componentBase from '../../../../../src/lib/component-base';
import GenericModal from '../../../../../shared/components/GenericModal/GenericModal';
import FSFlatButton from '../../../../../src/components/lib/FSFlatButton';

@componentBase('CustomLargeModal')
export default class CustomLargeModal extends GenericModal {
  static propTypes = {
    modalOpen: PropTypes.bool,
    closeModal: PropTypes.func,
    title: PropTypes.string,
    image: PropTypes.string,
    actionTitle: PropTypes.string,
    body: PropTypes.object,
    selectAction: PropTypes.func,
    secondaryActionTitle: PropTypes.string,
    secondaryActionStyle: PropTypes.object,
    secondaryActionBackgroundColor: PropTypes.string,
    secondaryActionHoverColor: PropTypes.string,
    disableButtons: PropTypes.bool.isRequired,
  };

  constructor(props, context) {
    super(props, context);

    this.state = {
      buttonsDisabled: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.disableButtons || nextProps.disableButtons === false) {
      this.setState({ buttonsDisabled: nextProps.disableButtons });
    }
  }

  handleModalClose = (e) => {
    if (e && e.preventDefault) e.preventDefault(); // onRequestClose does not pass event with preventDefault
    this.setState({ buttonsDisabled: true }, () => {
      this.props.closeModal();
    });
  }

  handleOptionSelect = () => {
    this.setState({ buttonsDisabled: true }, () => {
      this.props.selectAction();
    });
  }

  render() {
    const secondaryActionStyle = Object.assign({ marginBottom: '5px', marginRight: '10px', color: 'black' }, this.props.secondaryActionStyle);
    const actions = [
      <FSFlatButton
        label={this.props.secondaryActionTitle ? this.props.secondaryActionTitle : 'CANCEL'}
        primary={false}
        onClick={this.handleModalClose}
        style={FSFlatButton.style(secondaryActionStyle)}
        backgroundColor={this.props.secondaryActionBackgroundColor}
        hoverColor={this.props.secondaryActionHoverColor}
        disabled={this.state.buttonsDisabled}
      />,
      <a
        style={{
          display: 'block',
          width: '320px',
          backgroundColor: 'rgb(100, 188, 35)',
          textAlign: 'center',
          fontSize: '16px',
          lineHeight: '18px',
          padding: '10px 0',
          textDecoration: 'none',
          float: 'right',
        }}
        href='https://www.flightstats.com/company/contact/contact-a-representative-about-data-exports/'
        onClick={this.props.selectAction}
      >
        {this.props.actionTitle}
      </a>,
    ];

    if (this.context.mediaBreakpoint && this.context.mediaBreakpoint.value < 768) {
      actions.reverse();
    }

    return (
      <GenericModal
        closeModal={this.props.closeModal}
        modalOpen={this.props.modalOpen}
        body={this.props.body}
        headerIcon={this.props.image}
        headerString={this.props.title}
        isLargeModal
        largeActions={actions}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./modules/DataExports/components/ExportsSearch/children/CustomLargeModal.js